import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import './index.css';
import App from './App';
import OnboardingPage from './OnboardingPage';
import LegalPages from './LegalPages';
import reportWebVitals from './reportWebVitals';
import { auth0Audience } from './auth/auth0Config';
import api from './api/client';

const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN;
const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
const auth0Configured = Boolean(auth0Domain && auth0ClientId && auth0Audience);
const isOnboardingRoute = window.location.pathname.startsWith("/onboarding");
const isLegalRoute = ["/privacy", "/terms", "/sms-consent"].some((path) => window.location.pathname.startsWith(path));
const RootView = isLegalRoute ? LegalPages : isOnboardingRoute ? OnboardingPage : App;

const devPreviewAllowed =
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_DEV_PREVIEW === "true" &&
  ["localhost", "127.0.0.1", "::1"].includes(window.location.hostname);

function loadDevPreviewScript() {
  return new Promise((resolve) => {
    if (window.__CHARA_CREATE_DEV_PREVIEW__) {
      resolve(true);
      return;
    }
    const script = document.createElement("script");
    script.src = "/dev-preview.generated.js";
    script.async = true;
    script.onload = () => resolve(Boolean(window.__CHARA_CREATE_DEV_PREVIEW__));
    script.onerror = () => resolve(false);
    document.head.appendChild(script);
  });
}

async function loadDevPreview() {
  if (!devPreviewAllowed) return null;
  const loaded = await loadDevPreviewScript();
  if (!loaded || !window.__CHARA_CREATE_DEV_PREVIEW__) return null;
  const devPreview = window.__CHARA_CREATE_DEV_PREVIEW__();
  devPreview.install(api);
  return devPreview;
}

async function render() {
  const devPreview = await loadDevPreview();
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      {auth0Configured ? (
        <Auth0Provider
          domain={auth0Domain}
          clientId={auth0ClientId}
          authorizationParams={{
            redirect_uri: `${window.location.origin}${window.location.pathname}`,
            audience: auth0Audience,
          }}
          useRefreshTokens
          useRefreshTokensFallback
          cacheLocation="localstorage"
        >
          {isLegalRoute ? <RootView /> : <RootView auth0Configured devPreview={devPreview} />}
        </Auth0Provider>
      ) : (
        isLegalRoute ? <RootView /> : <RootView auth0Configured={false} devPreview={devPreview} />
      )}
    </React.StrictMode>
  );
}

render();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
